// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__ButtonLink__buttonLink{content:normal}", "",{"version":3,"sources":["webpack://./../../../src/internal/ButtonLink/ButtonLink.module.scss","webpack://./../../platform/@jutro/router/internal/ButtonLink/ButtonLink.module.css"],"names":[],"mappings":"AAAA,6BACE,cCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonLink": "jut__ButtonLink__buttonLink"
};
export default ___CSS_LOADER_EXPORT___;
